<template>
  <button class="dm-only" @click="onClick">
    <Icon :name="icon || 'game-icons:crossed-swords'" />
    <span class="title">
      <slot>Run Encounter</slot>
    </span>
  </button>
</template>

<script setup lang="ts">
import { type SetEncounterData } from '~/assets/bindings'
import { maps } from '~/assets/tabletopData'

const db = useDatabase()

const props = defineProps<{
  name?: string
  map?: string
  icon?: string
}>()

const onClick = async () => {
  const encounter = await getEncounter()
  console.log('running encounter: ', encounter)

  db.value?.reducers.setEncounter(encounter)
}

const getEncounter = async (): Promise<SetEncounterData> => {
  if (props.name) {
    const encounter = await fetch(`/encounters/${props.name}.json`)
      .then((res) => res.json())
      .catch((err) => console.error('Error fetching encounter:', err))
    const map = maps[encounter.map]
    encounter.fog = encounter?.fog?.map((f: any) => ({ ...f, kind: f.type }))
    return {
      map: encounter.map ? { name: encounter.map, ...map } : undefined,
      characters: encounter?.characters,
      fog: encounter?.fog,
    }
  } else if (props.map) {
    const map = maps[props.map]

    return {
      map: { name: props.map, ...map },
      characters: undefined,
      fog: [],
    }
  } else {
    return {
      map: undefined,
      characters: undefined,
      fog: undefined,
    }
  }
}
</script>

<style scoped lang="postcss">
button.dm-only {
  border-left: 1px solid var(--primary);
}

table button {
  margin-bottom: 0;
}

button > .title:not(:empty) {
  margin-left: 0.5em;
}
</style>
